import React, { useEffect, useState } from "react";

export default function OrderCompleteDetails({
  orderCreated,
  order,
  offer,
  profiles,
}) {
  const [projected, setProjected] = useState(0);
  const [subTotalVal, setSubTotalVal] = useState(0);
  const [feesAmt, setFeesAmt] = useState(0);
  const [credit, setCredit] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);

  useEffect(() => {
    let totalPrj = 0;
    let subtotal = 0;
    offer.map((itemOffer) => {
      subtotal = Number(subtotal) + Number(itemOffer.price);
    });
    setSubTotalVal(subtotal);
    setProjected(subtotal / 2);
    setCredit(order.credit);
    setFeesAmt(order.fees);
    // setGrandTotal(order.fees + order.amount - order.credit);
    setGrandTotal(order.grandtotal);
    console.log("🚀 ~ OrderCompleteDetails ~ order:", order);
  }, []);
  const getSubstring = (text) => {
    if (text?.includes("- Followerscount")) {
      const startIndex = text?.indexOf("- Followerscount");
      const last = "- Followerscount".length + 2;
      const remainingText = text?.substring(startIndex + last);
      return " (" + remainingText + " Followers)";
    } else {
      const remainingText = "";
    }
  };
  const getSubstringFun = (text) => {
    const str = text;
    const result = str?.split("-");
    //console.log(remainingText); // Output: ": and is very popular."
    return result[0];
  };
  function capitalizeFirstLetter(val) {
    return String(val)?.charAt(0)?.toUpperCase() + String(val)?.slice(1);
  }
  return (
    <>
      <div className="order-details">
        <div className="order-card">
          <div class="order-left detailsCart">
            <p>
              <strong>Ordered On:</strong> {order?.created_at}
            </p>

            <p>
              <strong>Order #:</strong> {order?.ref_id}
            </p>
            {/*<p><strong>Status:</strong> {capitalizeFirstLetter(order.status)}</p>*/}
          </div>

          <div className="order-body detailspage">
            {/*<div className="order-left detailsCart">
                            <p><strong>Amount:</strong> ${order.amount}</p>
                        </div>*/}
            <div className="orderDetailsBox">
              <div className="search-checkout-cart-number-holder">
                <div className="cart-price-row amountDetails">
                  <div>Subtotal</div>
                  <div className="subtotal">${subTotalVal?.toFixed(2)}</div>
                </div>
                {/*availableBalance > 0 &&
                                                        <div className="cart-price-row">
                                                            <div>From Available Balance</div>
                                                            <div className="subtotal">${100}</div>
                                                        </div>*/}
                <div className="cart-price-row amountDetails">
                  <div>Platform Fee</div>
                  <div className="subtotal">${feesAmt?.toFixed(2)}</div>
                </div>
                {credit > 0 && (
                  <div className="cart-price-row amountDetails">
                    <div>From Available Balance</div>
                    <div className="subtotal">- ${credit?.toFixed(2)}</div>
                  </div>
                )}
                <div className="cart-price-row amountDetails">
                  <div>Grand Total</div>
                  <div className="subtotal">${grandTotal?.toFixed(2)}</div>
                </div>
              </div>
            </div>
            <div className="order-right orderDetailsBox">
              <div>
                <div className="sidebar-cart orderDetailsCart ">
                  {offer?.length > 0 ? (
                    <>
                      <div className="search-checkout-added">
                        <div className="search-checkout-cart-items js-cart-items">
                          {offer?.length > 0 &&
                            offer?.map((cartItemLoop, index) => {
                              return (
                                <div
                                  key={index}
                                  className="search-checkout-item-holder"
                                >
                                  <div className="search-checkout-item">
                                    <div className="search-checkout-item-info-holder">
                                      <div className="search-checkout-item-title-holder">
                                        <div className="search-checkout-item-title">
                                          {cartItemLoop?.offer_type === "custom"
                                            ? getSubstringFun(
                                                cartItemLoop?.description
                                              )
                                            : cartItemLoop?.name}
                                        </div>
                                        <div className="bothStatusandPrice">
                                          <div className="search-checkout-item-price">
                                            {!orderCreated
                                              ? capitalizeFirstLetter(
                                                  cartItemLoop?.status
                                                ) + " "
                                              : ""}
                                          </div>
                                          <div className="search-checkout-item-price">
                                            ${cartItemLoop?.price}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="search-checkout-item-name">
                                        {cartItemLoop?.to_displayname}{" "}
                                        {getSubstring(
                                          cartItemLoop?.description
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
